import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {ServiceDefinitionVersionRoutingModule} from './service-definition-version-routing.module';
import {ServiceDefinitionVersionComponent} from './service-definition-version.component';
import {BreadcrumbModule} from '../../../components/breadcrumb/breadcrumb.module';
import {SharedModule} from '../../../shared/shared.module';
import {IconsModule} from '../../../icons/icons.module';
import {MatDividerModule} from '@angular/material/divider';
import {CarouselModule} from '../../../components/carousel/carousel.module';
import {CardModule} from '../card/card.module';
import {CapabilityCardModule} from '../../../components/capability-card/capability-card.module';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatExpansionModule} from "@angular/material/expansion";

@NgModule({
  declarations: [
    ServiceDefinitionVersionComponent
  ],
  imports: [
    CommonModule,
    ServiceDefinitionVersionRoutingModule,
    BreadcrumbModule,
    SharedModule,
    IconsModule,
    MatDividerModule,
    CarouselModule,
    CardModule,
    CapabilityCardModule,
    MatProgressSpinnerModule,
    MatExpansionModule
  ]
})
export class ServiceDefinitionVersionModule {
}
